import { useHistory } from "react-router-dom";

import { AssessmentContainer } from "./components/AssessmentContainer";

export function ACPSatisfactionSurvey() {
  const history = useHistory();

  return <ACPSatisfactionSurveyBody onSuccessCallback={() => history.push("/app/home")} />;
}

// used in the LoginRouter as a login task which receives the additional callback
export function ACPSatisfactionSurveyBody(props: { onSuccessCallback: () => void }) {
  return (
    <AssessmentContainer
      definitionId="acp_satisfaction_survey"
      taskType="COMPLETE_ACP_SATISFACTION_SURVEY"
      toastConfig={{
        heading: "Thank you for your feedback!",
        text: "Your responses help us improve your care experience.",
      }}
      {...props}
    />
  );
}
